var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1716_1887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 54
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57.6337,
    height: 54,
    fill: "#B335C6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1716_1887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8169 76.3226C58.4424 76.3226 82.4584 54.2389 82.4584 26.9972C82.4584 -0.244458 58.4424 -22.3281 28.8169 -22.3281C-0.808597 -22.3281 -24.8247 -0.244458 -24.8247 26.9972C-24.8247 54.2389 -0.808597 76.3226 28.8169 76.3226Z",
    fill: "url(#paint0_linear_1716_1887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1506 17.8203C36.1328 17.8203 35.2423 18.6392 35.2423 19.5751C35.2423 20.511 36.1328 21.3299 37.1506 21.3299C38.1684 21.3299 39.0589 20.511 39.0589 19.5751C39.0589 18.5222 38.1684 17.8203 37.1506 17.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8822 19.9219C24.5567 19.9219 21.1217 23.0804 21.1217 27.0579C21.1217 31.0354 24.5567 34.1941 28.8822 34.1941C33.2078 34.1941 36.6428 31.0354 36.6428 27.0579C36.6428 23.1973 33.2078 19.9219 28.8822 19.9219ZM28.8822 31.6204C26.0834 31.6204 23.9206 29.5146 23.9206 27.0579C23.9206 24.6012 26.2106 22.4955 28.8822 22.4955C31.6811 22.4955 33.8439 24.6012 33.8439 27.0579C33.8439 29.5146 31.6811 31.6204 28.8822 31.6204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1144 41.567H22.5194C17.3033 41.567 12.9777 37.7064 12.9777 32.7931V21.2114C12.9777 16.415 17.176 12.4375 22.5194 12.4375H35.1144C40.3305 12.4375 44.656 16.298 44.656 21.2114V32.7931C44.5288 37.7064 40.3305 41.567 35.1144 41.567ZM22.5194 15.3621C18.9571 15.3621 16.031 18.0528 16.031 21.3284V32.9099C16.031 36.1855 18.9571 38.8763 22.5194 38.8763H35.1144C38.6766 38.8763 41.6027 36.1855 41.6027 32.9099V21.3284C41.6027 18.0528 38.6766 15.3621 35.1144 15.3621H22.5194Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1716_1887",
    x1: -9.09491,
    y1: -7.86191,
    x2: 60.5089,
    y2: 67.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0011048,
    stopColor: "#FFE185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2094,
    stopColor: "#FFBB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#FF5176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    stopColor: "#F63395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#A436D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4EED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.40358471c7f6e3d44b16f56f5acead64.svg";
export { ForwardRef as ReactComponent };